import React, { useEffect, useRef } from 'react'
import './InputComp.css'
import BookSvg from '../../assets/icons/BookSvg'
import UserSvg from '../../assets/icons/UserSvg'
import UserCardSvg from '../../assets/icons/UserCardSvg'
// import Calendar from '../../assets/icons/Calendar'
import PhoneGreenSvg from '../../assets/icons/PhoneGreenSvg'
import Inputmask from 'inputmask' // Input mask kütüphanesini ekliyoruz
import InputMask from 'react-input-mask'

const InputComp = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  type = 'text',
  pattern = '',
  maxlength = '1000',
  svg = null,
  mask = '',
  errorText = '*Bu Alan Zorunludur.',
  name,
}) => {
  const svgs = (svg) => {
    switch (svg) {
      case 'Book':
        return <BookSvg width={'.9rem'} />
      case 'User':
        return <UserSvg width={'.9rem'} />
      case 'UserCard':
        return <UserCardSvg width={'.9rem'} />
      case 'Phone':
        return <PhoneGreenSvg width={'.9rem'} />
      default:
        return <UserCardSvg width={'.9rem'} />
    }
  }

  const inputRef = useRef(null)

  // Masking işlemini yapıyoruz (sadece eski Inputmask için, react-input-mask ile gerek yok)
  useEffect(() => {
    if (mask && inputRef.current && name !== 'tel') {
      const im = new Inputmask(mask)
      im.mask(inputRef.current)
    }
  }, [mask, name])

  // Karakter kısıtlaması için input event handler
  const handleInput = (e) => {
    if (name === 'adi' || name === 'soyadi') {
      // Sadece harf ve boşluk
      e.target.value = e.target.value.replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g, '')
    }
    // TC ve telefon için burada kısıtlama yapma, mask yeterli
  }

  return (
    <div className='inputDiv'>
      <div style={{ position: 'relative', width: '100%' }}>
        {svg && <div style={{ position: 'absolute', top: '8px', left: '20px' }}>{svgs(svg)}</div>}

        {name === 'tel' ? (
          <InputMask
            mask={mask}
            value={value}
            onChange={onChange}
            name={name}
            maskChar={null}
          >
            {(inputProps) => (
              <input
                {...inputProps}
                ref={inputRef}
                type={type}
                placeholder={placeholder}
                style={{
                  padding: svg ? '0.5rem 1rem 0.5rem 2.6rem' : '0.5rem 1rem 0.5rem 1rem',
                  borderColor: error ? 'red' : '#BCD8CC',
                }}
                // error={error} // kaldırıldı, gereksiz
                // maxLength={maxlength} // kaldırıldı, mask yeterli
              />
            )}
          </InputMask>
        ) : (
          <input
            ref={inputRef}
            name={name}
            label={type === 'radio' ? label : null}
            pattern={pattern}
            maxLength={name === 'tc' ? 11 : maxlength}
            type={type}
            value={value}
            style={{
              padding: svg ? '0.5rem 1rem 0.5rem 2.6rem' : '0.5rem 1rem 0.5rem 1rem',
              borderColor: error ? 'red' : '#BCD8CC',
            }}
            onChange={onChange}
            onInput={handleInput}
            placeholder={placeholder}
          />
        )}
      </div>

      {error && (
        <div
          style={{
            marginTop: '0.1rem',
            marginLeft: '0.5rem',
            fontSize: '9px',
            color: 'red',
          }}
        >
          {errorText}
        </div>
      )}
    </div>
  )
}

export default InputComp
